var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	44238: {
		fallback: () => (Promise.all([__webpack_require__.e(88830), __webpack_require__.e(2814), __webpack_require__.e(7511), __webpack_require__.e(49883)]).then(() => (() => (__webpack_require__(49883))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "22.0.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	88830: {
		fallback: () => (Promise.all([__webpack_require__.e(17141), __webpack_require__.e(31340)]).then(() => (() => (__webpack_require__(31340))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	2814: {
		fallback: () => (Promise.all([__webpack_require__.e(17141), __webpack_require__.e(23620)]).then(() => (() => (__webpack_require__(23620))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	29604: {
		fallback: () => (Promise.all([__webpack_require__.e(88830), __webpack_require__.e(21352)]).then(() => (() => (__webpack_require__(21352))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "22.0.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	66992: {
		fallback: () => (Promise.all([__webpack_require__.e(88830), __webpack_require__.e(2814), __webpack_require__.e(16613)]).then(() => (() => (__webpack_require__(16613))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "22.0.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	81128: {
		fallback: () => (Promise.all([__webpack_require__.e(88830), __webpack_require__.e(2814), __webpack_require__.e(29604), __webpack_require__.e(30597), __webpack_require__.e(17415)]).then(() => (() => (__webpack_require__(17415))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "22.0.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	30597: {
		fallback: () => (Promise.all([__webpack_require__.e(29604), __webpack_require__.e(66992), __webpack_require__.e(94967), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "22.0.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	63880: {
		fallback: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(13334))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/global-environments",

	},
	81380: {
		fallback: () => (Promise.all([__webpack_require__.e(44238), __webpack_require__.e(88830), __webpack_require__.e(2814), __webpack_require__.e(68750), __webpack_require__.e(81383)]).then(() => (() => (__webpack_require__(81383))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store",

	},
	59868: {
		fallback: () => (Promise.all([__webpack_require__.e(29604), __webpack_require__.e(66992), __webpack_require__.e(43900), __webpack_require__.e(63880), __webpack_require__.e(60130), __webpack_require__.e(76041), __webpack_require__.e(50033), __webpack_require__.e(69136), __webpack_require__.e(45808), __webpack_require__.e(59148)]).then(() => (() => (__webpack_require__(59148))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/utils",

	},
	2140: {
		fallback: () => (Promise.all([__webpack_require__.e(88830), __webpack_require__.e(2814), __webpack_require__.e(29604), __webpack_require__.e(86054), __webpack_require__.e(79010), __webpack_require__.e(35741)]).then(() => (() => (__webpack_require__(35741))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/flags",

	},
	68750: {
		fallback: () => (Promise.all([__webpack_require__.e(7511), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "22.0.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	12652: {
		fallback: () => (Promise.all([__webpack_require__.e(64690), __webpack_require__.e(66992), __webpack_require__.e(30597), __webpack_require__.e(9227)]).then(() => (() => (__webpack_require__(64690))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "22.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/icon",

	},
	40846: {
		fallback: () => (Promise.all([__webpack_require__.e(94967), __webpack_require__.e(30161)]).then(() => (() => (__webpack_require__(30161))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "22.0.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",

	},
	99886: {
		fallback: () => (__webpack_require__.e(34456).then(() => (() => (__webpack_require__(34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "22.0.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	26764: {
		fallback: () => (Promise.all([__webpack_require__.e(20946), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(63450))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/state/route",

	},
	79010: {
		fallback: () => (__webpack_require__.e(63391).then(() => (() => (__webpack_require__(63391))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/monitoring",

	},
	20402: {
		fallback: () => (Promise.all([__webpack_require__.e(29604), __webpack_require__.e(2140), __webpack_require__.e(81897)]).then(() => (() => (__webpack_require__(81897))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/access-control",

	},
	88470: {
		fallback: () => (Promise.all([__webpack_require__.e(79975), __webpack_require__.e(26019), __webpack_require__.e(5642), __webpack_require__.e(93482), __webpack_require__.e(4420), __webpack_require__.e(12587)]).then(() => (() => (__webpack_require__(12587))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "22.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/dialog",

	},
	4420: {
		fallback: () => (() => (__webpack_require__(79975))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "22.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/scrolling",

	},
	99737: {
		fallback: () => (__webpack_require__.e(66231).then(() => (() => (__webpack_require__(66231))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-device-detector",

	},
	21672: {
		fallback: () => (Promise.all([__webpack_require__.e(68750), __webpack_require__.e(85114)]).then(() => (() => (__webpack_require__(85114))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "angular-auth-oidc-client",

	},
	17548: {
		fallback: () => (Promise.all([__webpack_require__.e(29604), __webpack_require__.e(66992), __webpack_require__.e(30597), __webpack_require__.e(63880), __webpack_require__.e(79975), __webpack_require__.e(26019), __webpack_require__.e(60130), __webpack_require__.e(25559), __webpack_require__.e(75646), __webpack_require__.e(50033), __webpack_require__.e(5642), __webpack_require__.e(93482), __webpack_require__.e(24499), __webpack_require__.e(88470), __webpack_require__.e(27646), __webpack_require__.e(41935), __webpack_require__.e(84392)]).then(() => (() => (__webpack_require__(84392))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/webapp/shared/services/auth",

	},
	20946: {
		fallback: () => (Promise.all([__webpack_require__.e(44238), __webpack_require__.e(2814), __webpack_require__.e(81128), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(32175))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/router-store",

	},
	15132: {
		fallback: () => (Promise.all([__webpack_require__.e(35723), __webpack_require__.e(16373), __webpack_require__.e(2140), __webpack_require__.e(17716), __webpack_require__.e(25788)]).then(() => (() => (__webpack_require__(25788))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/comms-framework",

	},
	76382: {
		fallback: () => (Promise.all([__webpack_require__.e(31034), __webpack_require__.e(79817)]).then(() => (() => (__webpack_require__(79817))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/header",

	},
	43604: {
		fallback: () => (Promise.all([__webpack_require__.e(29604), __webpack_require__.e(66992), __webpack_require__.e(63880), __webpack_require__.e(68750), __webpack_require__.e(24499), __webpack_require__.e(8800)]).then(() => (() => (__webpack_require__(8800))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/webapp/shared/services/common",

	},
	48673: {
		fallback: () => (__webpack_require__.e(70347).then(() => (() => (__webpack_require__(70347))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/effects",

	},
	36988: {
		fallback: () => (Promise.all([__webpack_require__.e(48765), __webpack_require__.e(90353), __webpack_require__.e(31034), __webpack_require__.e(38223), __webpack_require__.e(29966)]).then(() => (() => (__webpack_require__(91798))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/layouts",

	},
	10398: {
		fallback: () => (__webpack_require__.e(8880).then(() => (() => (__webpack_require__(8880))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/webapp/shared/guards",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"2140": [
		2140
	],
	"2814": [
		2814
	],
	"4420": [
		4420
	],
	"5289": [
		43604
	],
	"17548": [
		17548
	],
	"19525": [
		15132,
		76382
	],
	"20946": [
		20946
	],
	"26764": [
		26764
	],
	"29604": [
		29604
	],
	"30597": [
		30597
	],
	"39607": [
		48673,
		36988,
		10398
	],
	"41935": [
		21672
	],
	"44238": [
		44238
	],
	"45808": [
		99737
	],
	"50033": [
		99886
	],
	"52285": [
		20402
	],
	"63880": [
		63880
	],
	"66992": [
		66992
	],
	"68750": [
		68750
	],
	"75646": [
		12652,
		40846
	],
	"79010": [
		79010
	],
	"81128": [
		81128
	],
	"81380": [
		81380
	],
	"86054": [
		59868
	],
	"88470": [
		88470
	],
	"88830": [
		88830
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}